/** @jsx jsx */
import { Status } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

interface JobApplicationPayExpressBestChoiceLabelProps {}

export const JobApplicationPayExpressBestChoiceLabel: FC<JobApplicationPayExpressBestChoiceLabelProps> = () => {
  const { t } = useTranslation("session");

  return (
    <Status size="sm" variant="primary">
      {t("JOB_REQUESTS.APPLY.CONSULTANT_PROFILE_FORM.PAYEXPRESS.POPULAR_CHOICE")}
    </Status>
  );
};
